import translation  from '../../../Translation/QR/DataProfil.json'

const Notification = () => {
  // Local data array
  const notisData = [
    { id: 1,message:"liasd ljsada sjdklas dasljd asljd" },
    { id: 2,message:"liasd ljsada sjdklas dasljd asljd" },
    { id: 3,message:"liasd ljsada sjdklas dasljd asljd" },
   
  ];

  return (
    <div className="bg-white rounded-md shadow-md border p-5  max-h-[50vh] overflow-auto">
      <h4 className="mb-3 text-lg font-semibold uppercase text-gray-700">
        {translation.Notification} 
      </h4>

      <div>
        <ul className="list-disc pl-6 space-y-2 text-gray-800">
          {notisData.map((item) => (
            <li key={item.id} className="leading-relaxed">
             {item.message}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Notification;
